
import { oz } from '@weft/utils';
import { CommitmentTypeSchema } from './commitment-type-schema';

export const NewCommitmentSchema = oz.object({
  amount: oz.number().nonnegative(),
  type: CommitmentTypeSchema,
});

export type NewCommitment = oz.infer<typeof NewCommitmentSchema>;